import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';

@Injectable({
  providedIn: 'root'
})
export class SsoSyncPasswordService {

  constructor(private httpclient: HttpClient, private httpHeaderService: HttpHeadersService){}

  post(token: string): Observable <any> {
    const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
    return this.httpclient.post(environment.servicePath + '/lfuser/sync_sso_password', token, { headers});


  }

}
